<template>
  <div class="device-add-container">
    <div class="control-panel">
      <div class="control-container">
        <div class="header-info">
          <i class="el-icon-link"></i>
          <span>绑定设备</span>
        </div>
        <div class="action-wrapper">
          <el-button @click="goBack" size="small">
            <i class="el-icon-back"></i> {{ $t('common.back') }}
          </el-button>
        </div>
      </div>
    </div>

    <el-card class="device-add-card" shadow="hover">
      <el-form ref="deviceForm" :model="deviceForm" :rules="rules" label-position="top" size="large">
        <div class="form-module">
          <div class="module-title">{{ $t('device.basicInfo') }} <el-tag size="small" type="warning" style="margin-left: 10px">智能设备</el-tag></div>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item :label="$t('device.deviceCode')" prop="deviceCode">
                <div class="device-code-input">
                  <el-input v-model="deviceForm.deviceCode" :placeholder="$t('device.deviceCode')" clearable @keyup.enter.native="handleDeviceCodeChange(deviceForm.deviceCode)" />
                  <el-button type="primary" @click="handleDeviceCodeChange(deviceForm.deviceCode)" :loading="queryLoading">
                    获取信息
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="设备种类">
                <el-input v-model="deviceCategoryLabel" placeholder="请先输入设备编码" disabled />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item :label="$t('device.deviceName')" prop="deviceName">
                <el-input v-model="deviceForm.deviceName" :placeholder="$t('device.deviceName')" disabled />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" v-if="deviceForm.productType === 'DEVICE'">
              <el-form-item :label="$t('device.macAddress')" prop="macAddress">
                <el-input v-model="deviceForm.macAddress" :placeholder="$t('device.macAddress')" disabled />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" v-if="deviceForm.productType === 'DEVICE'">
              <el-form-item :label="$t('device.deviceModel')" prop="board">
                <el-select v-model="deviceForm.board" :placeholder="$t('device.deviceModel')" clearable filterable style="width: 100%">
                  <el-option
                    v-for="item in boards"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" v-if="deviceForm.productType === 'DEVICE'">
              <el-form-item :label="$t('device.firmwareVersion')" prop="appVersion">
                <el-input v-model="deviceForm.appVersion" :placeholder="$t('device.firmwareVersion')" clearable />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="form-module">
          <div class="module-title">绑定信息</div>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="绑定用户" prop="userId">
                <el-select
                  v-model="deviceForm.userId"
                  filterable
                  clearable
                  placeholder="请选择用户"
                  style="width: 100%"
                  @change="handleUserChange"
                >
                  <el-option
                    v-for="user in userList"
                    :key="user.id"
                    :label="(user.username || user.name) + (user.name && user.username ? `(${user.name})` : '')"
                    :value="user.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="绑定智能体" prop="agentId">
                <el-select
                  v-model="deviceForm.agentId"
                  filterable
                  clearable
                  remote
                  :remote-method="handleAgentSearch"
                  :loading="agentLoading"
                  placeholder="请选择智能体"
                  style="width: 100%"
                  no-data-text="无匹配智能体"
                >
                  <el-option
                    v-for="agent in agentOptions"
                    :key="agent.id"
                    :label="agent.agentName"
                    :value="agent.id"
                  >
                    <span>{{ agent.agentName }}</span>
                    <span style="float: right; color: #8492a6; font-size: 12px;">{{ agent.agentCode || '' }}</span>
                  </el-option>
                </el-select>
                <span class="form-tip">仅显示当前用户拥有的智能体</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="form-module">
          <div class="module-title">{{ $t('device.otherInfo') }}</div>
          <el-form-item :label="$t('device.deviceRemark')" prop="deviceRemark">
            <el-input
              type="textarea"
              v-model="deviceForm.deviceRemark"
              :rows="4"
              :placeholder="$t('device.deviceRemark')"
              clearable
            />
          </el-form-item>
        </div>
      </el-form>

      <div class="form-actions">
        <el-button @click="goBack">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="handleSave" :loading="loading" :disabled="!canSave">确认绑定</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getProfileByDeviceCode, bindDeviceByCode } from '@/apis/device/device'
import { getUserList } from '@/apis/user/user'
import { getDictDataByType } from '@/apis/system/dict'
import request from '@/utils/request'

export default {
  name: 'DeviceAdd',
  data() {
    return {
      loading: false,
      queryLoading: false,
      deviceCategoryLabel: '',
      profileInfo: null,
      boards: [],
      userList: [],
      agentOptions: [],
      agentLoading: false,
      deviceForm: {
        productType: 'DEVICE',
        category: '',
        deviceName: '',
        deviceCode: '',
        macAddress: '',
        board: '',
        appVersion: '',
        userId: '',
        agentId: '',
        deviceRemark: '',
        status: 0
      },
      rules: {
        deviceCode: [
          { required: true, message: this.$t('device.deviceCodeRequired'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '请选择绑定用户', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    canSave() {
      if (!this.deviceForm.deviceCode || !this.deviceForm.deviceCode.trim()) return false
      if (!this.deviceForm.userId) return false
      if (!this.profileInfo) return false
      if (this.profileInfo.deviceExists && this.profileInfo.isBound) return false
      if (!this.profileInfo.exists && !this.profileInfo.deviceExists) return false
      return true
    }
  },
  created() {
    this.fetchUserList()
    this.fetchBoards()
  },
  methods: {
    async fetchBoards() {
      try {
        const data = await getDictDataByType('FIRMWARE_TYPE')
        this.boards = data || []
      } catch (error) {
        console.error('获取设备型号字典失败:', error)
      }
    },
    async handleDeviceCodeChange(val) {
      if (!val || !val.trim()) {
        this.deviceCategoryLabel = ''
        this.deviceForm.category = ''
        this.deviceForm.deviceName = ''
        this.deviceForm.macAddress = ''
        this.deviceForm.board = ''
        this.deviceForm.appVersion = ''
        this.profileInfo = null
        return
      }
      this.queryLoading = true
      this.profileInfo = null
      this.deviceForm.board = ''
      this.deviceForm.appVersion = ''
      this.deviceForm.macAddress = ''
      try {
        const data = await getProfileByDeviceCode(val.trim())
        if (data && data.exists) {
          this.profileInfo = data
          this.deviceForm.productType = data.productType === 'PERIPHERAL' ? 'PERIPHERAL' : 'DEVICE'
          this.deviceForm.category = data.category ? String(data.category) : ''
          this.deviceForm.deviceName = data.deviceName || ''
          // 设备尚未创建，从产品档案获取MAC地址
          this.deviceForm.macAddress = (data.profile && data.profile.macAddress) || data.macAddress || ''

          const dictType = 'DEVICE_TYPE'
          try {
            const categoryRes = await getDictDataByType(dictType)
            const categories = categoryRes.data || categoryRes || []
            const matchedCategory = categories.find(item => item.key === this.deviceForm.category)
            this.deviceCategoryLabel = matchedCategory ? matchedCategory.name : (data.deviceName || val)
          } catch (e) {
            this.deviceCategoryLabel = data.deviceName || val
          }

          if (data.deviceExists && data.isBound) {
            this.$message.warning('该设备编码已被其他用户绑定')
          }
        } else {
          this.$message.warning('未找到对应的编码信息，请检查设备编码')
          this.deviceCategoryLabel = ''
          this.deviceForm.category = ''
          this.deviceForm.deviceName = ''
          this.deviceForm.macAddress = ''
        }
      } catch (e) {
        console.error('查询编码失败:', e)
        this.$message.warning('未找到对应的编码信息，请检查设备编码')
        this.deviceCategoryLabel = ''
        this.deviceForm.category = ''
        this.deviceForm.deviceName = ''
        this.deviceForm.macAddress = ''
      } finally {
        this.queryLoading = false
      }
    },

    async fetchUserList() {
      try {
        const data = await getUserList({ limit: 1000 })
        const list = (data && data.list) || data || []
        this.userList = list
          .filter(user => user && String(user.status) !== '0')
          .map(user => ({
            ...user,
            id: String(user.userid || user.id)
          }))
      } catch (error) {
        console.error('获取用户列表失败:', error)
      }
    },

    async handleUserChange(userId) {
      this.deviceForm.agentId = ''
      this.agentOptions = []
      if (userId) {
        await this.fetchAgentOptions(userId)
      }
    },

    async fetchAgentOptions(userId) {
      this.agentLoading = true
      try {
        const res = await request({
          url: '/agent/all',
          method: 'get',
          params: { userId, limit: 1000 }
        })
        this.agentOptions = res.list || []
      } catch (error) {
        console.error('获取智能体列表失败:', error)
        try {
          const res = await request({
            url: '/agent/list',
            method: 'get',
            params: { userId }
          })
          this.agentOptions = Array.isArray(res) ? res : (res.list || [])
        } catch (err) {
          console.error('获取智能体列表失败(fallback):', err)
          this.agentOptions = []
        }
      } finally {
        this.agentLoading = false
      }
    },

    handleAgentSearch(query) {
      if (query) {
        this.agentOptions = this.agentOptions.filter(agent =>
          agent.agentName && agent.agentName.toLowerCase().includes(query.toLowerCase())
        )
      } else if (this.deviceForm.userId) {
        this.fetchAgentOptions(this.deviceForm.userId)
      }
    },

    goBack() {
      this.$router.back()
    },

    async handleSave() {
      if (!this.deviceForm.deviceCode || !this.deviceForm.deviceCode.trim()) {
        this.$message.warning('请输入设备编码')
        return
      }
      if (!this.deviceForm.userId) {
        this.$message.warning('请选择绑定用户')
        return
      }
      if (!this.profileInfo) {
        this.$message.warning('请先点击"获取信息"查询产品信息')
        return
      }

      this.$confirm('确认绑定该设备吗？', this.$t('common.tips'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        this.loading = true
        try {
          const data = {
            deviceCode: this.deviceForm.deviceCode.trim(),
            userId: this.deviceForm.userId
          }
          if (this.deviceForm.agentId) {
            data.agentId = this.deviceForm.agentId
          }
          if (this.deviceForm.productType === 'DEVICE') {
            if (this.deviceForm.board) {
              data.board = this.deviceForm.board
            }
            if (this.deviceForm.appVersion) {
              data.appVersion = this.deviceForm.appVersion
            }
          }
          await bindDeviceByCode(data)
          this.$message.success('设备绑定成功')
          this.$router.push('/device')
        } catch (error) {
          console.error('绑定设备失败:', error)
          const msg = (error.response && error.response.data && error.response.data.msg) || '绑定失败'
          this.$message.error(msg)
        } finally {
          this.loading = false
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.device-add-container {
  padding: 0;
}

.control-panel {
  margin-bottom: 24px;
}

.control-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #303133;
  font-size: 16px;
  font-weight: 500;
  
  i {
    font-size: 20px;
    color: #409eff;
  }
}

.action-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.device-add-card {
  margin-bottom: 20px;
  border-radius: 8px;
}

.form-module {
  margin-bottom: 30px;
}

.module-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  line-height: 1;
}

.form-actions {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.form-actions button {
  min-width: 100px;
  margin-left: 15px;
}

.device-code-input {
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-left: 8px;
}

:deep(.el-form-item__label) {
  font-weight: 500;
  color: #606266;
  padding-bottom: 8px;
}

:deep(.el-input__inner), :deep(.el-textarea__inner) {
  border-radius: 4px;
}

@media screen and (max-width: 768px) {
  .control-container {
    flex-direction: row;
    align-items: center;
  }
  
  .header-info span {
    display: none;
  }
}
</style>
